import React, { useState } from "react";
import UpTastingLogo from "../../../assets/images/hcb_logo_light.png";
import styled from "@emotion/styled";

const HomeComponent = ({ props }) => {

  const Wrapper = {
    height: "100vh",
    display: "flex",
    position: "relative",
    background: "black",
    justifyContent: "center",
    flexDirection: "column"
  };

  const LogoStyle = styled.img`
    max-width: 10vw;
    max-height: 10vh;
    margin: 4vh auto;
  `;

  const Text = styled.div`
    margin: 4vh auto;
    color: white;
    font-size: 3vh;
  `;

  return (
    <div style={Wrapper}>
      <LogoStyle src={UpTastingLogo} />
      <Text>{props?.strings?.notfound}</Text>
    </div>
  );
};

export default HomeComponent;
